module.exports = __webpack_public_path__ + "img/hero-desktop@2x.fe13ac80.webp";